import React from "react";
import "./frameModalSidebar.scss";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";
import { useGetPageQuery } from "../../redux/services/velmartAPI";
import StructureList from "../structureList/StructureList";

export const frameListTest = [
    { id: 0, title: "Frame-1" },
    { id: 1, title: "Frame-2" },
    { id: 2, title: "Frame-3" },
    { id: 3, title: "Frame-4" },
    { id: 4, title: "Frame-5" },
    { id: 5, title: "Frame-6" },
    { id: 6, title: "Frame-7" },
    { id: 7, title: "Frame-8" },
    { id: 8, title: "Frame-9" },
    { id: 9, title: "Frame-10" },
    { id: 10, title: "Frame-11" },
    { id: 11, title: "Frame-12" },
];

const FrameModalSidebar = ({ setActiveFrameId, activeFrameId, scrollToElementHandler }) => {
    // const setActiveFrameIdHandler = (id) => {
    //     scrollToElementHandler(id);
    //     setActiveFrameId(id);
    // };

    const { data: structure, refetch: refetchStructure } = useGetPageQuery("files/structure");

    return (
        <div className="modalSidebar">
            <div className="modalSidebar__column">
                <div className="modalSidebar__column-title">Зміст:</div>
                <div className="modalSidebar__column-item">
                    {structure && (
                        <StructureList
                            isDouble={true}
                            listData={structure}
                            isAllOpen={true}
                            scrollToElementHandler={scrollToElementHandler}
                            isShowIframes={true}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default FrameModalSidebar;
